var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFullscreenOff = function SvgFullscreenOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.5v7h-1v-5.294l-5.146 5.148-.708-.708L9.292 14.5H4v-1h7zm3-9v5.292l5.146-5.146.708.708-5.148 5.146H20v1h-7v-7h1z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
export default SvgFullscreenOff;